import createTable from './CompanyDetailsTable';

export default createTable({
  namePrefix: 'targetCompetitors',
  tableName: 'Competitors',
  columns: [{ field: 'competitor' }],
});
